import React, { useState } from "react";
import { Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import DraggableField from "../DraggableField/DraggableField";

import {
  closeContentBlocksNav,
  openContentBlocksNav
} from './ContentBlocksPanel.utils';

import styles from "../../../../../Reusables/components/ClientApproverSetting/ClientApproverSetting.module.css";

interface ContentBlock {
  BlockName: string;
}

interface ContentBlocksPanelProps {
  contentBlocksOpen: boolean;
  setContentBlocksOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setRulesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contentBlocksData: ContentBlock[];
  setContentBlockId: React.Dispatch<React.SetStateAction<string | undefined>>;
  setBlockName: React.Dispatch<React.SetStateAction<string>>;
  setBlockData: React.Dispatch<React.SetStateAction<string>>;
  setActive: React.Dispatch<React.SetStateAction<"Y" | "N">>;
  setStatus: React.Dispatch<React.SetStateAction<string | undefined>>;
  setContentBlockModelShow: React.Dispatch<React.SetStateAction<boolean>>;
  handleContentBlockShow: (
    setContentBlockId: React.Dispatch<React.SetStateAction<string | undefined>>,
    setBlockName: React.Dispatch<React.SetStateAction<string>>,
    setBlockData: React.Dispatch<React.SetStateAction<string>>,
    setActive: React.Dispatch<React.SetStateAction<"Y" | "N">>,
    setStatus: React.Dispatch<React.SetStateAction<string | undefined>>,
    setContentBlockModelShow: React.Dispatch<React.SetStateAction<boolean>>,
    block: any
  ) => void;
  forwizard?: boolean;
}

const ContentBlocksPanel: React.FC<ContentBlocksPanelProps> = ({
  contentBlocksOpen,
  setContentBlocksOpen,
  setRulesOpen,
  contentBlocksData,
  setContentBlockId,
  setBlockName,
  setBlockData,
  setActive,
  setStatus,
  setContentBlockModelShow,
  handleContentBlockShow,
  forwizard
}) => {
  const [searchText, setSearchText] = useState("");

  const filteredList = contentBlocksData.filter((obj) =>
    obj.BlockName.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <div
        className={
          contentBlocksOpen
            ? "contentblocks-button-wrapper contentblocks-active"
            : "contentblocks-button-wrapper"
        }
        style={{
          display: forwizard ? "none" : "",
        }}
      >
        <Button
          className="flex-column-center-center contentblocks-button"
          onClick={
            !contentBlocksOpen
              ? () => openContentBlocksNav(setContentBlocksOpen, setRulesOpen)
              : () => closeContentBlocksNav(setContentBlocksOpen)
          }
        >
          <Icon.BuildingFillGear
            style={{ color: "gray", fontSize: 16, marginBottom: 0 }}
          />
          <p>Content Blocks</p>
        </Button>
      </div>

      <div
        id="contentblocks"
        className={
          contentBlocksOpen
            ? "contentblocks fields-section-active"
            : "contentblocks"
        }
      >
        <div className="contentblocks-content">
          <div className={styles.dropdownSearchContainer}>
            <Icon.Search className={styles.searchIcon} />
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search field..."
              className={styles.dropdownSearch}
            />
          </div>
          <div className="contentblocks-column">
            {filteredList.map((block, index) => (
              <DraggableField
                key={index}
                label={block.BlockName}
                value={block.BlockName}
                type="Content Block"
                handleBtnClick={() =>
                  handleContentBlockShow(
                    setContentBlockId,
                    setBlockName,
                    setBlockData,
                    setActive,
                    setStatus,
                    setContentBlockModelShow,
                    block
                  )
                }
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentBlocksPanel;
